<div class="container-fluid">
  <div class="main-body">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title mb-3 mt-md-0 mt-4">
          <div class="d-flex align-items-center">
            <mat-icon color="primary" class="me-1">manage_accounts</mat-icon>
            <p class="ms-2 mb-0">{{ "PROFILE.TITLE" | translate }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row compact-inputs">
      <!-- Profile Card (Left Column) -->
      <div class="col-12 col-lg-4">
        <div class="card h-100">
          <div class="card-body">
            <div class="d-flex flex-column align-items-center text-center">
              <div class="position-relative mb-3">
                <img
                  [src]="
                    imagePreview == null
                      ? getDoc(form.data['imageId'])
                      : imagePreview
                  "
                  [alt]="'PROFILE.IMAGE_ALT' | translate"
                  class="profile-image"
                />
                <button
                  mat-mini-fab
                  color="primary"
                  class="position-absolute bottom-0 end-0"
                  matTooltip="{{ 'PROFILE.UPDATE_PROFILE' | translate }}"
                  data-bs-toggle="modal"
                  data-bs-target="#imageModal"
                >
                  <mat-icon>camera_alt</mat-icon>
                </button>
              </div>

              <!-- User Info -->
              <div class="text-center w-100">
                <h5 class="fw-bold text-truncate my-2">
                  {{ form.data["firstName"] }}
                  {{ form.data["lastName"] }}
                </h5>
                <p
                  class="text-muted mb-2 d-flex align-items-center justify-content-center"
                >
                  <mat-icon color="primary" class="me-1 icon-compact"
                    >mail</mat-icon
                  >
                  <span>{{ form.data["loginId"] }}</span>
                </p>
                <mat-chip class="mb-3" color="primary" variant="outlined">
                  {{ "PROFILE.ROLE_LABEL" | translate }}-
                  {{ form.data["roleName"] }}
                </mat-chip>
              </div>

              <!-- Quick Actions -->
              <div class="mt-2 profile-width-btn">
                <button
                  mat-stroked-button
                  color="primary"
                  data-bs-toggle="modal"
                  data-bs-target="#imageModal"
                  (click)="resetFileInput(file)"
                  matTooltip="{{ 'PROFILE.UPDATE_PROFILE' | translate }}"
                  class="w-100"
                >
                  <i class="fa fa-edit"></i>
                  <span class="ms-2">{{
                    "PROFILE.UPDATE_PROFILE" | translate
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Form (Right Column) -->
      <div class="col-12 col-lg-8">
        <div class="card h-100">
          <div class="card-header border-bottom-0 pb-0 pt-3 pt-md-4">
            <mat-card-title class="fw-bold mb-0 d-flex align-items-center">
              <mat-icon color="primary" class="me-2">edit</mat-icon>
              <h5 class="mb-0">{{ "PROFILE.TITLE" | translate }}</h5>
            </mat-card-title>
          </div>

          <mat-card-content class="p-3 p-md-4">
            <form class="needs-validation" novalidate #uiForm="ngForm">
              <div class="mb-4">
                <div *ngIf="form['error'] == false && form['message']">
                  <app-ncs-alert [message]="form['message']" type="success" />
                </div>
                <div *ngIf="form['error'] == true && form['message']">
                  <app-ncs-alert [message]="form['message']" type="danger" />
                </div>
              </div>

              <!-- Form Fields -->
              <div class="row g-3">
                <!-- First Name -->
                <div class="col-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100 mb-2 mb-2">
                    <mat-label>
                      {{ "PROFILE.FIRST_NAME" | translate }}
                    </mat-label>
                    <input
                      matInput
                      (input)="validateFirstName($event)"
                      required
                      [(ngModel)]="form.data['firstName']"
                      name="firstName"
                      #firstName="ngModel"
                      type="text"
                      maxlength="30"
                    />
                    <mat-error *ngIf="firstName.errors?.['required']">
                      {{ "PROFILE.VALIDATION.FIRST_NAME_REQUIRED" | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Last Name -->
                <div class="col-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>
                      {{ "PROFILE.LAST_NAME" | translate }}
                    </mat-label>
                    <input
                      matInput
                      (input)="validateLastName($event)"
                      required
                      [(ngModel)]="form.data['lastName']"
                      name="lastName"
                      #lastName="ngModel"
                      type="text"
                      maxlength="30"
                    />
                    <mat-error *ngIf="lastName.errors?.['required']">
                      {{ "PROFILE.VALIDATION.LAST_NAME_REQUIRED" | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <!-- Login ID (Readonly) -->
                <div class="col-12">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>
                      {{ "PROFILE.LOGIN_ID" | translate }}
                    </mat-label>
                    <input
                      matInput
                      readonly
                      [(ngModel)]="form.data['loginId']"
                      type="email"
                      name="loginId"
                    />
                  </mat-form-field>
                </div>

                <!-- Role (Readonly) -->
                <div class="col-12">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <mat-label>
                      {{ "PROFILE.ROLE" | translate }}
                    </mat-label>
                    <input
                      matInput
                      readonly
                      [(ngModel)]="form.data['roleName']"
                      type="text"
                      name="roleName"
                    />
                  </mat-form-field>
                </div>
              </div>
              <!-- Action Buttons -->
              <div
                class="d-flex flex-column gap-3 flex-md-row justify-content-center justify-content-lg-between align-items-center mt-4 pt-4 border-top"
              >
                <div class="mb-3 mb-md-0">
                  <button
                    mat-stroked-button
                    color="warn"
                    class="d-flex align-items-center justify-content-center"
                    (click)="resetProfileImage()"
                    matTooltip="{{ 'PROFILE.RESET_PROFILE' | translate }}"
                    matTooltipPosition="above"
                  >
                    <i class="fa fa-eraser eraser-warn-dark"></i>
                    <span class="ms-2">{{
                      "PROFILE.RESET_PROFILE" | translate
                    }}</span>
                  </button>
                </div>

                <div
                  class="d-flex gap-3 flex-wrap justify-content-between justify-content-lg-start"
                >
                  <!-- Change Password Button -->
                  <button
                    mat-stroked-button
                    color="primary"
                    class="d-flex align-items-center justify-content-center"
                    data-bs-toggle="modal"
                    matTooltipPosition="above"
                    data-bs-target="#changepass"
                    matTooltip="{{ 'PROFILE.CHANGE_PASSWORD' | translate }}"
                  >
                    <mat-icon class="me-2">key</mat-icon>
                    <span>{{ "PROFILE.CHANGE_PASSWORD" | translate }}</span>
                  </button>

                  <!-- Save Button -->
                  <button
                    mat-stroked-button
                    color="primary"
                    class="d-flex align-items-center justify-content-center"
                    matTooltip="{{ 'BUTTONS.SAVE' | translate }}"
                    matTooltipPosition="above"
                    [disabled]="uiForm['invalid']"
                    (click)="save()"
                  >
                    <mat-icon class="me-2">save</mat-icon>
                    {{ "BUTTONS.SAVE" | translate }}
                  </button>
                </div>
              </div>
            </form>
          </mat-card-content>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Image Preview Modal (Optional enhancement) -->
<div class="modal fade" id="imagePreviewModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ "PROFILE.IMAGE_PREVIEW" | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
        ></button>
      </div>
      <div class="modal-body text-center">
        <img
          [src]="
            imagePreview == null ? getDoc(form.data['imageId']) : imagePreview
          "
          [alt]="'PROFILE.IMAGE_PREVIEW' | translate"
          class="img-fluid rounded shadow"
        />
      </div>
    </div>
  </div>
</div>

<!-- Change Password Modal -->
<div
  class="modal fade"
  id="changepass"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="changepassLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="changepassLabel">
          {{ "PROFILE.CHANGE_PASSWORD" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'BUTTONS.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <!-- Error / Success Message (unchanged) -->
        <div>
          <p *ngIf="cpForm['error'] == false && cpForm['message']">
            <app-ncs-alert [message]="cpForm['message']" type="success" />
          </p>
          <p *ngIf="cpForm['error'] == true && cpForm['message']">
            <app-ncs-alert [message]="cpForm['message']" type="danger" />
          </p>
        </div>

        <form class="row compact-inputs dropdown-pd-none" #cpform="ngForm">
          <div class="col-12 mb-3">
            <!-- Material input field with floating label -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ "PROFILE.OLD_PASSWORD" | translate }}</mat-label>
              <input
                matInput
                required
                [(ngModel)]="cpForm['oldPassword']"
                name="oldPassword"
                #oldPassword="ngModel"
                [type]="showOldPassword ? 'text' : 'password'"
                id="oldPassword"
              />

              <!-- Material Eye Icon Button -->
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="icon-pd-none"
                (click)="togglePassword('old')"
                [attr.aria-label]="
                  showOldPassword ? 'Hide password' : 'Show password'
                "
              >
                <mat-icon class="icon-compact text-secondary">{{
                  showOldPassword ? "visibility" : "visibility_off"
                }}</mat-icon>
              </button>
            </mat-form-field>

            <div *ngIf="oldPassword.errors?.['required']" class="text-danger">
              <small>{{
                "PROFILE.VALIDATION.OLD_PASSWORD_REQUIRED" | translate
              }}</small>
            </div>
          </div>
          <div class="col-12 mb-3">
            <!-- Material input field with floating label -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ "PROFILE.NEW_PASSWORD" | translate }}</mat-label>
              <input
                matInput
                required
                [(ngModel)]="cpForm['newPassword']"
                name="newPassword"
                #newPassword="ngModel"
                [type]="showNewPassword ? 'text' : 'password'"
                id="newPassword"
              />

              <!-- Material Eye Icon Button -->
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="icon-pd-none"
                (click)="togglePassword('new')"
                [attr.aria-label]="
                  showNewPassword ? 'Hide password' : 'Show password'
                "
              >
                <mat-icon class="icon-compact text-secondary">{{
                  showNewPassword ? "visibility" : "visibility_off"
                }}</mat-icon>
              </button>
            </mat-form-field>

            <div *ngIf="newPassword.errors?.['required']" class="text-danger">
              <small>{{
                "PROFILE.VALIDATION.NEW_PASSWORD_REQUIRED" | translate
              }}</small>
            </div>
          </div>
          <div class="col-12 mb-3">
            <!-- Material input field with floating label -->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{
                "PROFILE.CONFIRM_PASSWORD" | translate
              }}</mat-label>
              <input
                matInput
                required
                [(ngModel)]="cpForm['confirmPassword']"
                name="confirmPassword"
                #confirmPassword="ngModel"
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
              />

              <!-- Material Eye Icon Button -->
              <button
                mat-icon-button
                matSuffix
                type="button"
                class="icon-pd-none"
                (click)="togglePassword('confirm')"
                [attr.aria-label]="
                  showConfirmPassword ? 'Hide password' : 'Show password'
                "
              >
                <mat-icon class="icon-compact text-secondary">{{
                  showConfirmPassword ? "visibility" : "visibility_off"
                }}</mat-icon>
              </button>
            </mat-form-field>

            <div
              *ngIf="confirmPassword.errors?.['required']"
              class="text-danger"
            >
              <small>{{
                "PROFILE.VALIDATION.CONFIRM_PASSWORD_REQUIRED" | translate
              }}</small>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          [disabled]="cpform['invalid']"
          (click)="changePassword()"
          class="px-4"
        >
          <mat-icon>save</mat-icon> {{ "PROFILE.UPDATE_PASSWORD" | translate }}
        </button>
        <button mat-stroked-button color="warn" data-bs-dismiss="modal">
          <mat-icon>close</mat-icon> {{ "BUTTONS.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Image Update Modal -->
<div
  class="modal fade"
  id="imageModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="imageModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="imageModalLabel">
          {{ "PROFILE.UPDATE_PROFILE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'BUTTONS.CLOSE' | translate"
          (click)="cancelCropping()"
        ></button>
      </div>
      <div class="modal-body compact-inputs dropdown-pd-none">
        <mat-form-field
          appearance="outline"
          class="w-100 mt-3"
          floatLabel="always"
        >
          <mat-label>{{ "PROFILE.SELECT_IMAGE" | translate }}</mat-label>
          <input
            #file
            type="file"
            id="imageId"
            name="imageId"
            accept="image/jpeg, image/jpg, image/png, image/gif"
            (click)="onFileChooseClicked(file)"
            (change)="
              file.files &&
                onFileChanged($event, 'imageId', form.data['imageId'])
            "
            style="display: none"
          />
          <input
            matInput
            readonly
            [value]="
              file.files && file.files.length > 0 ? file.files[0].name : ''
            "
            (click)="file.click()"
            placeholder="{{ 'PROFILE.SELECT_IMAGE' | translate }}"
            style="cursor: pointer"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="file.click()"
            class="icon-pd-none"
            type="button"
            style="cursor: pointer"
          >
            <mat-icon class="text-secondary icon-compact">attach_file</mat-icon>
          </button>
        </mat-form-field>

        <!-- Error messages (unchanged) -->
        <div *ngIf="fileError" class="text-danger">
          {{ "PROFILE.ERRORS.INVALID_FILE_TYPE" | translate }}
        </div>
        <div *ngIf="imageSize" class="text-danger">
          {{ "PROFILE.ERRORS.FILE_SIZE_LIMIT" | translate: { size: 1 } }}
        </div>

        <!-- Buttons Row -->
        <div class="button-row my-3" *ngIf="showCropper">
          <!-- Zoom In -->
          <button
            mat-stroked-button
            color="primary"
            (click)="zoomIn()"
            [class.enabled]="transform.flipV"
            class="me-1 mb-2"
          >
            <mat-icon>zoom_in</mat-icon>
            <small>{{ "PROFILE.ZOOM_IN" | translate }}</small>
          </button>

          <!-- Zoom Out -->
          <button
            mat-stroked-button
            color="primary"
            (click)="zoomOut()"
            [class.enabled]="transform.flipV"
            class="me-1 mb-2"
          >
            <mat-icon>zoom_out</mat-icon>
            <small>{{ "PROFILE.ZOOM_OUT" | translate }}</small>
          </button>

          <!-- Rotate Right -->
          <button
            mat-stroked-button
            color="primary"
            (click)="rotateRight()"
            [class.enabled]="transform.flipV"
            class="me-1 mb-2"
          >
            <mat-icon>rotate_right</mat-icon>
            <small>{{ "PROFILE.ROTATE_RIGHT" | translate }}</small>
          </button>

          <!-- Rotate Left -->
          <button
            mat-stroked-button
            color="primary"
            (click)="rotateLeft()"
            [class.enabled]="transform.flipV"
            class="me-1 mb-2"
          >
            <mat-icon>rotate_left</mat-icon>
            <small>{{ "PROFILE.ROTATE_LEFT" | translate }}</small>
          </button>

          <!-- Flip Horizontal -->
          <button
            mat-stroked-button
            color="primary"
            (click)="flipHorizontal()"
            [class.enabled]="transform.flipH"
            class="me-1 mb-2"
          >
            <mat-icon>flip</mat-icon>
            <small>{{ "PROFILE.FLIP_HORIZONTAL" | translate }}</small>
          </button>

          <!-- Flip Vertical -->
          <button
            mat-stroked-button
            color="primary"
            (click)="flipVertical()"
            [class.enabled]="transform.flipV"
            class="me-1 mb-2"
          >
            <mat-icon>flip</mat-icon>
            <small>{{ "PROFILE.FLIP_VERTICAL" | translate }}</small>
          </button>
        </div>

        <!-- Preview and Cropper Row -->
        <div class="row preview-row">
          <div class="col-12">
            <div class="cropper-wrapper">
              <!-- Image Cropper Component (unchanged) -->
              <image-cropper
                [imageChangedEvent]="imageChangedEvent"
                [imageURL]="imageURL"
                [hidden]="hidden"
                [disabled]="disabled"
                [alignImage]="alignImage"
                [roundCropper]="roundCropper"
                [backgroundColor]="backgroundColor"
                imageAltText="Alternative image text"
                [allowMoveImage]="allowMoveImage"
                [hideResizeSquares]="hideResizeSquares"
                [canvasRotation]="canvasRotation"
                [aspectRatio]="aspectRatio"
                [containWithinAspectRatio]="containWithinAspectRatio"
                [maintainAspectRatio]="maintainAspectRatio"
                [cropperStaticWidth]="cropperStaticWidth"
                [cropperStaticHeight]="cropperStaticHeight"
                [cropperMinWidth]="cropperMinWidth"
                [cropperMinHeight]="cropperMinHeight"
                [cropperMaxWidth]="cropperMaxWidth"
                [cropperMaxHeight]="cropperMaxHeight"
                [resetCropOnAspectRatioChange]="resetCropOnAspectRatioChange"
                [(transform)]="transform"
                [onlyScaleDown]="true"
                format="png"
                (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded()"
                (cropperReady)="cropperReady($event)"
                (loadImageFailed)="loadImageFailed()"
                (transformChange)="transformChange($event)"
                [style.display]="showCropper ? 'block' : 'none'"
                output="base64"
              >
              </image-cropper>
            </div>
          </div>
          <div class="col-12" *ngIf="showCropper">
            <!-- Using Material Typography for Preview title -->
            <div class="preview-card">
              <h6 class="fw-bold">{{ "PROFILE.PREVIEW" | translate }}</h6>
              <div class="text-center">
                <img
                  *ngIf="croppedImage"
                  [src]="croppedImage"
                  [alt]="'PROFILE.CROPPED_PREVIEW' | translate"
                  class="cropped-preview"
                />
                <!-- Show placeholder when no image -->
                <div *ngIf="!croppedImage" class="no-preview">
                  <mat-icon class="no-preview-icon">image</mat-icon>
                  <p class="text-muted">
                    {{ "PROFILE.NO_PREVIEW" | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          class="btn-sm"
          [disabled]="!croppedImage"
          (click)="saveCroppedImage()"
          [attr.data-bs-dismiss]="!imageSize ? 'modal' : null"
        >
          <mat-icon>save</mat-icon> {{ "BUTTONS.SAVE" | translate }}
        </button>

        <button
          mat-stroked-button
          color="warn"
          class="btn-sm app-btn me-2"
          data-bs-dismiss="modal"
          (click)="cancelCropping()"
        >
          <mat-icon>close</mat-icon> {{ "BUTTONS.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>